import { useContext } from 'react';

import { WorkspaceContext } from '@containers/workspace/provider';
import { WorkspaceProviderInterface } from '@typings';

const useWorkspaceContext = (): WorkspaceProviderInterface => useContext<WorkspaceProviderInterface>(WorkspaceContext);

export default useWorkspaceContext;
